function useEmployeeSalaryBonus() {
  return {};
}

export default useEmployeeSalaryBonus;
